import React, { useCallback, useEffect, useState, useRef } from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  SafeAreaView,
  FlatList,
  Linking,
  Dimensions,
  Share,
  Platform,
  Image,
  Animated,
  TouchableOpacity,
} from 'react-native';
import { Color, globalFontStyle, globalStyle } from '../../assets';
import Colors from '../../assets/Color/Colors';
import Width from '../../assets/Width';
import CommonModal from '../../commonComponents/commonModal';
import Header from '../../commonComponents/Header';
import ProbeIcon from '../../commonComponents/ProbeIcon';
import BuySell from './childComponents/BuySell';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
  fetchProbesRequestDetails,
  setProbeEmpty,
} from '../home/redux/home.action';
import { getEventDetails } from './redux/events.actions';
import {
  showLoader,
  hideLoader,
} from '../../commonComponents/Loader/loader.actions';
import OrderBook from './childComponents/OrderBook';
import EventHeaderSection from './childComponents/EventHeaderSection';
import MultiOptions from './childComponents/MultiOptions';
import Chart from './childComponents/Chart';
import AboutEvent from './childComponents/AboutEvent';
import EventDetailsBox from './childComponents/EventDetailsBox';
import { HeaderOptionsTab } from './childComponents/HeaderOptionsTab';
import RenderHtmlScore from '../hashtag/renderHtml';
import TradingView from './childComponents/TradingView';
import {
  atob,
  buildLink,
  giveCorrectPrice,
  isMobile,
  timeLagFromCurrentTime,
  trackMoengageEvent,
} from '../../utils/commonMethods';
import {
  globalConfigurableData,
  globalConst,
  GlobalScreens,
} from '../../utils/globalConstant';
import moment from 'moment';
import {
  ORDER_STATUS_CLOSED_CANCEL,
  ORDER_STATUS_CLOSED_SELL,
} from '../portfolio/portfolio.constants';
import { useFocusEffect } from '@react-navigation/native';
import { getUser } from '../Profile/redux/profile.action';
import { getContestCoinsBalance } from '../contest/redux/contest.action';
import TimerComp from '../../commonComponents/TimerComp';
import { getCurrentRoute } from '../../navigation/rootNavigation';
import { globalImport } from '../../common/globalImports';
import ContestHandling from '../contest/childComponents/ContestHandling';
import { fetchLivePorfolio } from '../portfolio/redux/portfolio.action';
import AsyncStorage from '@react-native-async-storage/async-storage';
import FormTextLabel from '../../commonComponents/FormTextLabel';
import { Button } from '../../components/core/Button';
import YoutubePlayerReact from '../home/childComponents/youtubePlayerReact';
import LiveView from '../../commonComponents/LiveView';
import ShareEvent from '../../commonComponents/ShareEvent';
import { imgHeader, powertrade_btn, defaulteventimage } from "../../utils/images";
import FastImage from "../../common/FastImage";
import Tooltip from "react-native-walkthrough-tooltip";
import { getSubcategoryImage } from "../../utils/subcategoryImages";
// import * as Sharing from 'expo-sharing';

const Events = ({
  eventInfo,
  eventDetails,
  fetchProbesRequestDetails,
  route,
  getEventDetails,
  showLoader,
  hideLoader,
  navigation,
  wsConnected,
  ws,
  setProbeEmpty,
  getUser,
  getContestCoinsBalance,
}) => {
  const [isShowBuyModal, setIsShowBuyModal] = useState(false);
  const [isShowCoinPromo, setIsShowCoinPromo] = useState(false);

  const dispatch = useDispatch();
  const [orderBookSelectedData, setOrderBookSelectedData] = useState({
    callvalue: 'Y',
    isShow: true,
    isShowLiquidity: false,
    isPowerTrade: false
  });
  const [apiRespnseUiData, setApiResponseUiData] = useState({
    isShow: false,
    orderData: null,
  });
  const logedIn = useSelector(({ utilReducer }) => utilReducer.isAppLogin);
  let userInfo = useSelector(({ profile }) => profile.profileData);

  const [multiEventCurrentIndex, setMultiEventCurrentIndex] = React.useState(0);
  const eventId = route?.params?.eventId;
  const isMulti = route?.params?.isMulti;
  const contestId = route?.params?.contestId;
  const [responseMultiEvents, setResponseMultiEvents] = useState([]);
  const [showAbout, setShowAbout] = useState(false);
  const [showMarketResolution, setShowMarketResolution] = useState(false);
  const [showOrderBook, setShowOrderBook] = useState(false);
  const liveDataNew = eventDetails?.liveCard?.text
    ? atob(eventDetails?.liveCard?.text)
    : null;

  const ll =
    '<div> <div style="display: flex; align-items: end; padding: 12px 15px;gap: 10px" class="app-font-sub-heading app-red-error event-heading-style"> LIVE <p class="app-font-sub-text app-light-grey"> tournament_name </p> </div> <div style="padding: 10px 15px 10px;" class="app-font-body app-grey"> <div class="app-font-sub-text-bold app-black"> <div class="live-data-details-row"> <p> firt_team </p> <div> <p> value1 <span class="app-font-sub-text app-light-grey"> subvalue1 </span></p> </div> </div> <div class="live-data-details-row"> <p> second_team </p> <div> <p> value2 <span class="app-font-sub-text app-light-grey"> subvalue2 </span></p> </div> </div></div> </div> </div>';

  const globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );
  const [isYesSelected, setIsYesSelected] = useState(true);
  const [toolTipVisible, setToolTipVisible] = useState(false);

  const onBtnClick = (isYes = false, showLiquidity = false, isPowerTrade = false) => {
    const data = {
      callvalue: isYes ? 'Y' : 'N',
      isShow: true,
      isShowLiquidity: showLiquidity,
      isPowerTrade: isPowerTrade,
    };

    setOrderBookSelectedData(data);

    setIsShowBuyModal(true);
  };

  useEffect(() => {
    if (logedIn) {
      getUser();
    }
  }, []);

  function nav(page) {
    if (page) {
      Linking.openURL(page);
    }
  }

  const onOrderBookClick = callVal => {
    trackMoengageEvent('order_book_clicked');
    const data =
      callVal?.callvalue === 'N'
        ? { newYCP: 100 - callVal.coins, callvalue: 'Y', isShow: true }
        : { newNCP: 100 - callVal.coins, callvalue: 'N', isShow: true };
    setOrderBookSelectedData(data);
    isMobile() && setIsShowBuyModal(true);
  };

  useEffect(() => {
    trackMoengageEvent('Page Visit', {
      Page: 'Event',
    });
    //alert(eventData?.id);

    async function fetchData() {
      const responseEvents = await fetchProbesRequestDetails(
        null,
        eventId,
        false,
        contestId,
      );
      setResponseMultiEvents(responseEvents?.probes || []);
      if (responseEvents?.probes?.length > 0) {
        handleMultiClickEvent(
          responseEvents.probes[multiEventCurrentIndex].id,
          0,
        );
      }
    }
    if (!isMulti) {
      getSingleEventdetails();
    } else {
      fetchData();
    }
    return () => {
      setProbeEmpty();
    };
  }, [route?.params?.probeInfo]);

  const getSingleEventdetails = async () => {
    const currRoute = currentRoute || window?.location?.pathname;
    if (
      !globalImport.isWeb ||
      currRoute.includes('ContestEvents') ||
      currRoute.includes('Event')
    ) {
      showLoader();
    }

    await getEventDetails(eventId, contestId);
    await fetchProbesRequestDetails(
      { probeid: eventId },
      undefined,
      null,
      contestId,
    );
    if (
      !globalImport.isWeb ||
      currRoute.includes('ContestEvents') ||
      currRoute.includes('Event')
    ) {
      hideLoader();
    }
  };

  let _eventInfo = eventInfo?.probes || [];
  if (
    route?.params?.probeInfo &&
    moment().unix() > moment.utc(route?.params?.probeInfo?.endsat).unix()
  ) {
    _eventInfo = route?.params?.probeInfo;
  } else {
    _eventInfo = _eventInfo.length > 0 ? _eventInfo[0] : null;
  }

  useFocusEffect(
    React.useCallback(() => {
      if (wsConnected === 1 && ws) {
        try {
          ws.send(
            JSON.stringify({
              topic: contestId
                ? `fantasy-probe-detail_${isMulti ? _eventInfo?.id : eventId}`
                : `probe-detail_${isMulti ? _eventInfo?.id : eventId}`,
              action: 'subscribe',
            }),
          );
          ws.send(
            JSON.stringify({
              topic: contestId
                ? `fantasy-probe-time-series_${isMulti ? _eventInfo?.id : eventId
                }`
                : `probe-time-series_${isMulti ? _eventInfo?.id : eventId}`,
              action: 'subscribe',
            }),
          );
        } catch (e) { }
      }
      return () => {
        if (wsConnected === 1 && ws) {
          try {
            ws.send(
              JSON.stringify({
                topic: contestId
                  ? `fantasy-probe-detail_${isMulti ? _eventInfo?.id : eventId}`
                  : `probe-detail_${isMulti ? _eventInfo?.id : eventId}`,
                action: 'unsubscribe',
              }),
            );
            ws.send(
              JSON.stringify({
                topic: contestId
                  ? `fantasy-probe-time-series_${isMulti ? _eventInfo?.id : eventId
                  }`
                  : `probe-time-series_${isMulti ? _eventInfo?.id : eventId}`,
                action: 'unsubscribe',
              }),
            );
          } catch (e) { }
        }
      };
    }, [_eventInfo?.id, wsConnected, ws, contestId]),
  );

  useEffect(() => {
    if (moment().unix(new Date()) > moment.utc(_eventInfo?.endsat).unix()) {
      setApiResponseUiData({
        isShow: true,
        orderData: ORDER_STATUS_CLOSED_SELL,
      });
    }
  }, [_eventInfo?.endsat]);

  let isDisableTradePrivate = false;

  let currentRoute = getCurrentRoute();

  const FormElement = useCallback(() => {
    return currentRoute === 'Event' || currentRoute === 'ContestEvents' ? (
      <BuySell
        _eventInfo={_eventInfo}
        onTradeClickReloadEventApi={onTradeClickReloadEventApi}
        apiRespnseUiData={apiRespnseUiData}
        orderBookSelectedData={orderBookSelectedData}
        //onBottomSheetClose={onBottomSheetClose}
        //onBottomSheetOpen={onOpenBottomSheet}
        invested_amount={eventDetails?.invested_amount}
        closeSheet={onBottomSheetClose}
      />
    ) : null;
  }, [
    _eventInfo,
    orderBookSelectedData,
    onTradeClickReloadEventApi,
    apiRespnseUiData,
  ]);
  //_eventInfo;

  const onTradeClickReloadEventApi = useCallback(
    (orderStatus, showLiquidity = false, isPowerTrade = false) => {
      if (!orderStatus) {
        setApiResponseUiData({ isShow: false, orderData: null });
        setOrderBookSelectedData(null);
        setIsShowBuyModal(false);
        return;
      }
      //fetchLivePorfolio();

      setApiResponseUiData({
        isShow: true,
        orderData: orderStatus,
        showLiquidity: showLiquidity,
        isPowerTrade: isPowerTrade
      });
      if (orderStatus?.respData?.show_promo_message) {
        setIsShowCoinPromo(true);
      }
      let orderTrack = orderStatus;
      if (orderStatus?.data) {
        orderTrack = orderTrack.data;
      }
      trackMoengageEvent('order status', {
        executed: orderTrack?.success
          ? orderTrack?.unmatched > 0
            ? 'partial'
            : 'success'
          : 'failed',
      });

      orderBookSelectedData && setOrderBookSelectedData(null);

      getEventDetails(isMulti ? _eventInfo?.id : eventId, contestId);
      if (isMulti) {
        fetchProbesRequestDetails(
          { probeid: _eventInfo?.id },
          undefined,
          true,
          contestId,
        );
      } else {
        fetchProbesRequestDetails(
          { probeid: eventId },
          undefined,
          true,
          contestId,
        );
      }

      logedIn && getUser();
      logedIn && getContestCoinsBalance(contestId);
    },
    [_eventInfo?.id],
  );

  const onBottomSheetClose = () => {
    setIsShowBuyModal(false);
    setOrderBookSelectedData(null);
    if (isShowCoinPromo) {
      setIsShowCoinPromo(false);
    }
    setApiResponseUiData({
      isShow: false,
      orderData: null,
    });
  };

  const handleMultiClickEvent = async (id, index, openPopUp) => {
    const currRoute = currentRoute || window?.location?.pathname;
    if (
      !globalImport.isWeb ||
      currRoute.includes('ContestEvents') ||
      currRoute.includes('Event')
    ) {
      showLoader();
    }

    await getEventDetails(id, contestId);
    await fetchProbesRequestDetails({ probeid: id }, undefined, false, contestId);
    setMultiEventCurrentIndex(index);
    if (
      !globalImport.isWeb ||
      currRoute.includes('ContestEvents') ||
      currRoute.includes('Event')
    ) {
      hideLoader();
    }

    if (openPopUp === 'yes') {
      onBtnClick(true);
    } else if (openPopUp === 'no') {
      onBtnClick(false);
    }
  };

  const child = (
    <ShareEvent
      eventName={_eventInfo?.title}
      eventId={eventId}
      isMulti={isMulti ? 'true' : 'false'}
    />
  );

  const shareMethod = async () => {
    showLoader();
    trackMoengageEvent('Clicked on Share Event', {
      id: _eventInfo?.id,
    });
    if (logedIn) {
      const link = buildLink(
        _eventInfo?.title,
        _eventInfo?.id,
        userInfo?.userid,
        hideLoader,
      );
      //hideLoader();
    } else {
      const eventName = _eventInfo?.title;
      const link = _eventInfo?.sharelink;
      const msg =
        'Hey, What do you think will happen? \n' +
        eventName +
        ' Click on this link ' +
        link +
        ' to participate';

      await Share.share({
        message: msg,
      }).then(() => {
        hideLoader();
      });

      // if (Platform.OS === "web") {
      //   if(Sharing.isAvailableAsync()){
      //     await Sharing.shareAsync(msg, []).then(() => {
      //       hideLoader();
      //     });
      //   }
      // } else {
      //   await Share.share({
      //     message: msg,
      //   }).then(() => {
      //     hideLoader();
      //   });
      // }
    }
  };

  useEffect(() => {
    showPowerTradeTip();
  }, []);

  const showPowerTradeTip = async () => {
    let powerTrade;
    if (globalImport.isWeb) {
      powerTrade = window.localStorage.getItem('powerTrade');
    } else {
      powerTrade = await AsyncStorage.getItem('powerTrade');
    }
    if (!powerTrade && !globalImport.isWeb) {
      setTimeout(() => {
        setToolTipVisible(true);
      }, 500);
    }
  };

  const openPowerTrade = async () => {
    if (globalImport.isWeb) {
      localStorage.setItem('powerTrade', 'true');
    } else {
      await AsyncStorage.setItem('powerTrade', 'true');
    }
    onBtnClick(false, false, true);
  };

  const redirectionClick = () => {
    trackMoengageEvent('Portfolio', { 'Referral Screen': 'Event' });
    if (contestId) {
      navigation.navigate('ContestPortfolio', {
        contestId: contestId,
        tab: true,
        merge: true,
      });
    } else {
      navigation.navigate({
        name: 'Portfolio',
        params: { tab: true },
        merge: true,
      });
    }
  };

  return (
    <>
      <SafeAreaView style={{ flexGrow: 1 }}>
        <View style={{
          position: 'sticky',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 10,
          backgroundColor: 'white',
        }}>
          {contestId > 0 ? (
            <ContestHandling
              contestId={contestId}
              chatLink={_eventInfo?.live_chat_link}
              eventId={_eventInfo?.id}
              fantasyData={_eventInfo?.fantasy}
              shareLink={_eventInfo?.sharelink}
            />
          ) : isMobile() ? (
            <Header
              isInternalPage={false}
              navigation={navigation}
              shareMethod={shareMethod}
              children={child}
            />
          ) : (
            <Header selected={'Markets'} />
          )}
        </View>
        <ScrollView
          style={{ flex: 1 }}
          overScrollMode="never"
          nestedScrollEnabled={Platform.OS === 'web' ? false : true}
          keyboardShouldPersistTaps={'handled'}
          showsVerticalScrollIndicator={false}
          contentContainerStyle={[
            {
              flexGrow: 1,
              paddingBottom: globalImport?.isWeb ? 50 : 150,
            },
            !isMobile() ? {
              display: 'flex',
            } : {}
          ]}>
          <View style={[
            { flexDirection: 'row', flex: 1 },
            !isMobile() ? {
              width: '100%'
            } : {},
          ]}>
            <View
              style={
                isMobile()
                  ? { paddingHorizontal: 16, paddingTop: 15, flex: 1 }
                  : {
                    paddingHorizontal: 0,
                    paddingTop: 20,
                    flex: 1,
                  }
              }>
              <View style={{
                flexDirection: isMobile() ? 'column' : 'row',
                alignItems: isMobile() ? 'stretch' : 'center',
                marginRight: 12,
                backgroundColor: 'white',
                gap: isMobile() ? 0 : 16
              }}>
                <View style={{ 
                  flexDirection: 'row', 
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: isMobile() ? '100%' : 'auto'
                }}>
                  <View style={{ flexDirection: 'row', gap: 12 }}>
                    <View style={{ position: 'relative' }}>
                      <Image
                        source={{ 
                          uri: _eventInfo?.imageurl || 
                               getSubcategoryImage(_eventInfo?.subcategory) || 
                               defaulteventimage() 
                        }}
                        style={[
                          {
                            borderRadius: 4,
                            marginRight: 0,
                            marginBottom: isMobile() ? 12 : 0,
                            resizeMode: 'cover'
                          },
                          isMobile() ? {
                            width: 60,
                            height: 60,
                          } : {
                            width: 64,
                            height: 64,
                          }
                        ]}
                      />
                      {_eventInfo?.probe_type === 'promo' && (
                        <View style={{
                          position: 'absolute',
                          left: 0,
                          right: 0,
                          bottom: isMobile() ? 12 : 0,
                          paddingVertical: isMobile() ? 2 : 4,
                          backgroundColor: globalConfigurableData.primaryBtnColor,
                          borderBottomLeftRadius: 4,
                          borderBottomRightRadius: 4,
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}>
                          <Image
                            source={require('../../assets/images/fantasy_selected.webp')}
                            style={{
                              width: isMobile() ? 16 : 20,
                              height: isMobile() ? 16 : 20,
                            }}
                            contentFit="contain"
                          />
                        </View>
                      )}
                    </View>
                  </View>
                  {isMobile() && (
                    <View style={{ 
                      flexDirection: 'row', 
                      gap: 8, 
                      flexWrap: 'wrap',
                      alignItems: 'center',
                      justifyContent: 'flex-end'
                    }}>
                      {_eventInfo?.category && !contestId ? (
                        <Button
                          variant="outline"
                          size="sm"
                          onPress={() => {
                            dispatch(setHomeFilterCategory(_eventInfo?.category));
                            navigation.navigate('Home');
                            const jumpToAction = TabActions.jumpTo('Markets');
                            navigation.dispatch(jumpToAction);
                          }}
                          style={[
                            globalStyle.outerElementBox,
                            styles.categoryStyle,
                          ]}
                        >
                          {_eventInfo?.category}
                        </Button>
                      ) : null}
                      {_eventInfo?.hashtags?.length > 0 ? (
                        <Button
                          variant="outline"
                          size="sm"
                          onPress={() => {
                            navigation.navigate('HashTag', {
                              hash_tag: _eventInfo?.hashtags[0],
                              selectedSubCategory: _eventInfo.subcategory,
                            });
                          }}
                          style={[globalStyle.outerElementBox, styles.categoryStyle]}
                        >
                          {_eventInfo?.hashtags}
                        </Button>
                      ) : null}
                    </View>
                  )}
                </View>
                <View style={{
                  flex: 1,
                  flexDirection: 'column',
                  justifyContent: !isMobile() && !(_eventInfo?.subtitle || _eventInfo?.description) ? 'center' : 'flex-start',
                  minHeight: isMobile() ? 'auto' : 64,
                }}>
                  <View style={{
                    flexDirection: isMobile() ? 'column' : 'row',
                    justifyContent: 'space-between',
                    alignItems: isMobile() ? 'flex-start' : 'center',
                    gap: isMobile() ? 8 : 16
                  }}>
                    <Text
                      style={[
                        globalFontStyle.appFontEventTitle,
                        {
                          color: globalConfigurableData.primaryTextColor1,
                          flexWrap: 'wrap',
                          marginBottom: 4,
                          fontSize: isMobile() ? 24 : 24,
                          lineHeight: isMobile() ? 28 : 32,
                          flex: 1,
                          fontWeight: isMobile() ? 600 : 700,
                        },
                      ]}
                    >
                      {_eventInfo?.title}
                    </Text>
                    {!isMobile() && (
                      <View style={{ 
                        flexDirection: 'row', 
                        gap: 8, 
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'flex-end'
                      }}>
                        {_eventInfo?.category && !contestId ? (
                          <Button
                            variant="outline"
                            size="sm"
                            onPress={() => {
                              dispatch(setHomeFilterCategory(_eventInfo?.category));
                              navigation.navigate('Home');
                              const jumpToAction = TabActions.jumpTo('Markets');
                              navigation.dispatch(jumpToAction);
                            }}
                            style={[
                              globalStyle.outerElementBox,
                              styles.categoryStyle,
                            ]}
                          >
                            {_eventInfo?.category}
                          </Button>
                        ) : null}
                        {_eventInfo?.hashtags?.length > 0 ? (
                          <Button
                            variant="outline"
                            size="sm"
                            onPress={() => {
                              navigation.navigate('HashTag', {
                                hash_tag: _eventInfo?.hashtags[0],
                                selectedSubCategory: _eventInfo.subcategory,
                              });
                            }}
                            style={[globalStyle.outerElementBox, styles.categoryStyle]}
                          >
                            {_eventInfo?.hashtags}
                          </Button>
                        ) : null}
                      </View>
                    )}
                  </View>
                  <Text
                    style={[
                      globalFontStyle.appFontRegular,
                      {
                        color: globalConfigurableData.secondaryTextColor1,
                        fontSize: isMobile() ? 16 : 18,
                        marginBottom: ((_eventInfo?.subtitle && _eventInfo?.subtitle.trim()) || (_eventInfo?.description && _eventInfo?.description.trim())) ? 10 : 0,
                        display: ((_eventInfo?.subtitle && _eventInfo?.subtitle.trim()) || (_eventInfo?.description && _eventInfo?.description.trim())) ? 'flex' : 'none'
                      },
                    ]}
                  >
                    {_eventInfo?.subtitle || _eventInfo?.description}
                  </Text>
                </View>
              </View>
              {isMulti && (
                <MultiOptions
                  responseMultiEvents={responseMultiEvents}
                  handleMultiClickEvent={handleMultiClickEvent}
                  multiEventCurrentIndex={multiEventCurrentIndex}
                />
              )}
              {!isMulti && (
                <EventHeaderSection
                  eventDetails={eventDetails}
                  _eventInfo={_eventInfo}
                  isYesSelected={isYesSelected}
                  setIsYesSelected={setIsYesSelected}
                  onBtnClick={onBtnClick}
                  navigation={navigation}
                  isContestCard={contestId}
                  style={{ marginBottom: 10 }}
                />
              )}

              {/* Video Section */}
              {(eventDetails?.liveCard?.videoKey || eventDetails?.liveView?.videoKey) && (
                <View style={styles.sectionContainer}>
                  <LiveView videoKey={eventDetails?.liveCard?.videoKey || eventDetails?.liveView?.videoKey} />
                </View>
              )}

              {/* TradingView Section */}
              {_eventInfo?.widget_title && (
                <View style={[styles.sectionContainer, {
                  backgroundColor: GlobalScreens.Event.StatsBlock
                }]}>
                  <TradingView widget_title={_eventInfo?.widget_title} />
                </View>
              )}

              {/* Live Stats/Scorecard Section */}
              {liveDataNew && (
                <View style={styles.sectionContainer}>
                  <View style={{
                    borderRadius: 8,
                    backgroundColor: GlobalScreens.Event.StatsBlock,
                  }}>
                    <RenderHtmlScore liveDataNew={liveDataNew} />
                  </View>
                  <View style={{
                    flexDirection: 'row',
                    paddingTop: 10,
                    paddingHorizontal: 15
                  }}>
                    <FormTextLabel
                      labelStyles={[
                        globalFontStyle.appFontSmallText,
                        {
                          color: globalConfigurableData.secondaryTextColor1,
                          marginRight: 5,
                        },
                      ]}
                      label={'Last Updated'}
                    />
                    <Text style={[
                      globalFontStyle.appFontSmallText,
                      {
                        color: globalConfigurableData.tertiaryTextColor1,
                        marginRight: 5,
                      },
                    ]}>
                      {timeLagFromCurrentTime(eventDetails?.liveCard?.time)}
                    </Text>
                  </View>
                </View>
              )}

              {/* YouTube Video Section */}
              {eventDetails?.liveView?.videoKey && (
                <View style={styles.sectionContainer}>
                  <LiveView videoKey={eventDetails?.liveView?.videoKey} />
                </View>
              )}

              {!eventDetails?.liveCard && eventDetails?.timeSeriesData?.length > (globalConfigData?.timelineMinPoints || 19) && (
                <View style={styles.sectionContainer}>
                  <Chart
                    graphData={eventDetails?.timeSeriesData}
                    isNo={!isYesSelected}
                  />
                </View>
              )}

              {/* Order Book Section */}
              {_eventInfo?.is_price_editable && (
                <EventDetailsBox
                  title={'Orderbook'}
                  eventDetails={eventDetails}
                  _eventInfo={_eventInfo}
                  onOrderBookClick={onOrderBookClick}
                  isSelected={true}
                />
              )}

              {/* About Section */}
              <EventDetailsBox
                title={'Market Stats and Timeline'}
                text={<AboutEvent eventDetails={eventDetails} _eventInfo={_eventInfo} />}
                eventDetails={eventDetails}
                _eventInfo={_eventInfo}
                isAboutSection={true}
                isSelected={true}
              />

              {/* Market Resolution Section */}
              <EventDetailsBox
                text={_eventInfo?.resolution}
                title={'Market Resolution(MR)'}
                eventDetails={eventDetails}
                _eventInfo={_eventInfo}
                onOrderBookClick={onOrderBookClick}
                isSelected={true}
              />

              <View style={{ height: 60 }} />
            </View>
            {_eventInfo && !isMobile() ? (
              <View style={{ marginLeft: 30, flex: 0.5, marginTop: 20 }}>
                {FormElement()}
              </View>
            ) : null}
          </View>
        </ScrollView>
        {isMobile() ? (
          <View style={[
            Platform.OS === 'web'
              ? styles.bottomAbsBtnBarWeb
              : styles.bottomAbsBtnBar,
            { zIndex: 20 }
          ]}>
            {Date.parse(_eventInfo?.endsat) < Date.now() ? (
              <View style={styles.bottomAbsBtnBarEvent}>
                <Button
                  variant="black"
                  onPress={() => {
                    setTimeout(() => {
                      navigation.navigate('Markets');
                    }, globalConst?.buttonTimer);
                  }}
                  style={styles.btnExternalStyle}
                  translate={true}
                >
                  Market is closed
                </Button>
              </View>
            ) : (
              <>
                <TimerComp end_time={_eventInfo?.endsat} isHome={'event'} />
                <View style={styles.bottomAbsBtnBarEvent}>
                  {eventDetails?.invested_amount > 0 && (
                    <View style={styles.investmentInfo}>
                      <View style={{ flexDirection: 'row', alignItems: 'baseline' }}>
                        <Text style={styles.investmentText}>
                          Current investment is {eventDetails?.invested_amount}
                        </Text>
                        <TouchableOpacity onPress={redirectionClick}>
                          <Text style={[styles.investmentText, { textDecorationLine: 'underline', marginLeft: 8, color: Colors.tradexBlue }]}>
                            Check Portfolio
                          </Text>
                        </TouchableOpacity>
                      </View>
                    </View>
                  )}
                  {isMulti && (
                    <Text
                      numberOfLines={1}
                      style={{
                        ...globalFontStyle.appFontSubTextBold,
                        color: globalConfigurableData.primaryTextColor1,
                        paddingBottom: 10,
                        flex: 1,
                        textAlign: 'center',
                      }}>
                      {_eventInfo?.alternate_title}
                    </Text>
                  )}
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}>
                    <View style={{ flex: 1, flexDirection: 'row', gap: 8 }}>
                      <Button
                        variant="yes"
                        onPress={() => onBtnClick(true)}
                        style={{ 
                          flex: 1,
                          height: 50,
                        }}
                        textStyle={{
                          fontSize: 16,
                          fontWeight: '600',
                        }}
                        disabled={isDisableTradePrivate}
                      >
                        Yes {giveCorrectPrice({ yPrice: eventDetails?.newYCP })}
                      </Button>
                      <Button
                        variant="no"
                        onPress={() => onBtnClick(false)}
                        style={{ 
                          flex: 1,
                          height: 50,
                        }}
                        textStyle={{
                          fontSize: 16,
                          fontWeight: '600',
                        }}
                        disabled={isDisableTradePrivate}
                      >
                        No {giveCorrectPrice({ nPrice: eventDetails?.newNCP })}
                      </Button>
                    </View>
                    {(logedIn && _eventInfo?.is_price_editable && globalConfigData?.enablePoweTrade) ? (
                      <Tooltip
                        isVisible={toolTipVisible}
                        contentStyle={{
                          ...globalStyle.toolTipStyle,
                          backgroundColor: globalConfigurableData.primaryTextColor1,
                          borderColor: globalConfigurableData.primaryTextColor1,
                        }}
                        content={
                          <Text
                            style={{
                              ...globalFontStyle.appFontSubText,
                              color: Colors.bgWhite,
                            }}
                          >
                            Power Trade
                          </Text>
                        }
                        placement="top"
                        onClose={() => setToolTipVisible(false)}
                        showChildInTooltip={false}
                        disableShadow={true}
                        backgroundColor={"rgba(0,0,0)"}
                        allowChildInteraction={true}
                      >
                        <Button
                          variant="icon"
                          onPress={() => {
                            setTimeout(() => {
                              openPowerTrade();
                            }, globalConst?.buttonTimer);
                          }}
                          style={{ marginLeft: 10 }}
                          icon={powertrade_btn()}
                          iconStyle={{ tintColor: Colors.bgWhite }}
                          iconSize={30}
                          backgroundColor={Colors.tradexBlue}
                        />
                      </Tooltip>
                    ) : null}
                  </View>
                </View>
              </>
            )}
          </View>
        ) : null}
      </SafeAreaView>
      <CommonModal
        onModalCallBack={isShowCoinPromo ? () => { } : onBottomSheetClose}
        customModalStyle={[
          styles.modalView,
          isShowCoinPromo ? { paddingTop: 0 } : {},
        ]}
        showModal={isShowBuyModal}
        persistent={isShowCoinPromo}>
        {isShowBuyModal && <View>{FormElement()}</View>}
      </CommonModal>
    </>
  );
};

const mapStateToProps = store => ({
  //loading: store.event.ld_eventData,
  //errors: store.event.er_eventData,
  eventDetails: store.eventReducer?.eventDetails,
  eventInfo: store.probesReducer?.mutiFilteredData,
  wsConnected: store?.liveReducer?.connected,
  ws: store?.liveReducer?.wsRef,
  //appIdle: store?.utilCommonData?.appIdle,
});

const mapDispatchToProps = {
  getEventDetails,
  getUser,
  fetchProbesRequestDetails,
  //fetchLivePorfolio,
  showLoader,
  hideLoader,
  setProbeEmpty,
  getContestCoinsBalance,
};

export default connect(mapStateToProps, mapDispatchToProps)(Events);

const styles = StyleSheet.create({
  btnExternalStyle: {
    borderRadius: 100,
  },
  eventTitle: {
    flex: 1,
    marginRight: 15,
    alignSelf: 'center',
  },
  eventPrice: {
    color: Colors.yesColor,
    marginBottom: 12,
  },
  eventRightPanel: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 4,
  },
  eventRightText: {
    color: Colors.black,
    paddingLeft: 10,
  },
  modalContainer: {
    backgroundColor: 'rgba(23, 23, 23, 0.8)',
    flex: 1,
  },
  modalView: {
    backgroundColor: globalConfigurableData.cardBgColor,
    paddingHorizontal: 0,
    paddingTop: 16,
    paddingBottom: 0,

    position: 'absolute',
    width: Width.width,

    bottom: 0,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 6,
  },
  liquidityBtn: {
    width: 26,
    height: 26,
    backgroundColor: 'rgba(10, 87, 255, 0.1);',
    borderRadius: 13,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 4,
  },
  liquidityBtnText: {
    ...globalFontStyle.appSmall10,
    color: Colors.tradexBlue,
  },
  categoryStyle: {
    paddingHorizontal: 10,
    paddingVertical: 8,
    backgroundColor: '#F4F4F4',
  },
  categoryStyleSelected: {
    backgroundColor: Color.black,
    color: 'white',
  },
  bottomAbsBtnBar: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: Colors.bgWhite,
    zIndex: 20,
    elevation: 5,
    ...(Platform.OS === 'web' ? {
      boxShadow: '0px -2px 4px rgba(0, 0, 0, 0.1)',
    } : {}),
  },
  bottomAbsBtnBarWeb: {
    position: globalImport?.isWeb ? 'sticky' : 'relative',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: Colors.bgWhite,
    zIndex: 20,
    elevation: 5,
    ...(Platform.OS === 'web' ? {
      boxShadow: '0px -2px 4px rgba(0, 0, 0, 0.1)',
    } : {}),
  },
  bottomAbsBtnBarEvent: {
    paddingHorizontal: 16,
    paddingVertical: 13,
    borderTopColor: GlobalScreens.Event.borderColor,
    borderTopWidth: 0.75,
    backgroundColor: globalConfigurableData.cardBgColor,
    flex: 1,
  },
  bottomButtonStyles: {
    paddingVertical: 12,
    flex: 1,
    alignItems: 'center',
    flexDirection: 'row',
    borderRadius: 8,
    justifyContent: 'center',
    backgroundColor: globalConfigurableData.noBtnBlock,
  },
  sectionContainer: {
    marginBottom: 15,
    backgroundColor: 'white',
    borderRadius: 8,
    borderWidth: 0.75,
    borderColor: GlobalScreens.Event.borderColor,
    overflow: 'hidden',
  },
  investmentInfo: {
    paddingBottom: 12,
    alignItems: 'center',
  },
  investmentText: {
    ...globalFontStyle.appFontSubTextBold,
    color: globalConfigurableData.primaryTextColor1,
    marginBottom: 4,
  },
  portfolioLink: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.secondaryTextColor1,
  },
});
